export default __webpack_public_path__ + "static/media/celular-grupos.6ade19a4.png";